import { render, staticRenderFns } from "./SignRevokeAoA.vue?vue&type=template&id=2a446a88"
import script from "./SignRevokeAoA.vue?vue&type=script&lang=js"
export * from "./SignRevokeAoA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports